import React, { useState, useEffect } from 'react';
import LazyLoad from 'react-lazyload';
import { Helmet } from "react-helmet-async";
import { RowsPhotoAlbum } from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

import 'react-photo-album/rows.css';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import '../css/PhotoGallery.css';

export default function GalleryWithLightbox() {
    const [photos, setPhotos] = useState([]);
    const [index, setIndex] = useState(-1);

    useEffect(() => {
        fetch('/json/galleryDataEPK.json')
            .then((res) => res.json())
            .then((data) => {
                const formatted = data.map((img) => ({
                    src: img.thumb,       // ✅ Use thumbnail for photo album display
                    original: img.src,    // ✅ Store full image separately for lightbox
                    width: img.width,            // real width of thumb
                    height: img.height,           // real height of thumb
                    alt: img.alt,
                }));
                setPhotos(formatted);
            })
            .catch(console.error);
    }, []);

    function renderPhoto({ photo }) {
        return (
            <div style={{ width: '100%', padding: '0.25rem' }}>
                <LazyLoad height={150} offset={100} once>
                    <img
                        src={photo.thumb}
                        alt={photo.alt}
                        className="photo-thumb"
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                            display: 'block',
                        }}
                    />
                </LazyLoad>
            </div>
        );
    }

    const metaPhoto = index >= 0 ? photos[index] : photos[0];

    return (
        <div className="gallery">
            
            <span>Press Photos (Click on image to expand)</span>

            <RowsPhotoAlbum
                photos={photos}
                targetRowHeight={150}
                onClick={({ index }) => setIndex(index)}
                renderPhoto={renderPhoto}
            />

            <Lightbox
                slides={photos.map(({ original, alt }) => ({ src: original, alt }))}
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
            />
        </div>
    );
}
